import constants from '../constants';
import getIconDialogCommonTraits from '../helpers/get-icon-dialog-common-traits';
import trackEvent from './track-event';

const { events } = constants;

export default function trackSelectIconSearchClicked({
  dialogId,
  targetElementId,
  premiumAvailable,
  tabId,
}) {
  const traits = {
    dialogId,
    premiumAvailable,
    tabId,
    ...getIconDialogCommonTraits(targetElementId),
  };

  trackEvent(events.SELECT_ICON_SEARCH_CLICKED, traits);
}
